import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EvendProduct, EvendProductType } from '../models/evendProduct';
import { BrandService } from '../services/brand.service';
import { CategoryService } from '../services/category.service';
import { ProductService } from '../services/product.service';
import { TagService } from "../services/tag.service";
import { EvendProductTag } from "../models/evendProduct";
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ProductContent } from "../models/productContent";
import { ProductCategory } from '../models/productCategory';
import { ProductBrand } from '../models/productBrand';

declare var $: any;

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {
  @ViewChild('errorSwal') private errorSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;

  evendProducts = [new EvendProduct()];
  loading = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    private brandService: BrandService,
    private tagService: TagService,
    private productService: ProductService) { }
  selectedFiles: File[] = [];
  productTypes: EvendProductType[];
  productType: EvendProductType;
  isHot: boolean = false;
  categories: ProductCategory[];
  brands: ProductBrand[];
  tags: EvendProductTag[];
  ingredients: ProductContent[];
  submitted = false;
  imagesFormData: FormData[] = [new FormData()];

  brandPage = 1;
  brandPages = 1;
  categoryPage = 1;
  categoryPages = 1;
  tagPage = 1;
  tagPages = 1;
  typePage = 1;
  typePages = 1;
  selector: string = '.add-evend-product-list';


  ngOnInit() {
    this.productService.getEvendProductTypes(this.typePage).subscribe(res => {
      this.productTypes = res.docs;
      this.productType = this.productTypes[0];
      this.typePages = res.pages;
    }, error => {
      console.log(error);
      if (error.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
    this.categoryService.getCategories(this.categoryPage).subscribe(res => {
      this.categories = res.docs;
      this.categoryPages = res.pages;
    }, error => {
      console.log(error);
      if (error.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
    this.brandService.getAllBrands(this.brandPage).subscribe(res => {
      this.brands = res.docs;
      this.brandPages = res.pages;
    }, error => {
      console.log(error);
      if (error.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
    this.getevendProductTags();
    /* this.evendProducts.forEach((evendProduct) => {
      evendProduct.status = -1;
    }); */
  }

  getevendProductTags() {
      this.tagService.getAllTags(this.tagPage).subscribe(res => {
        this.tags = res.docs;
        this.tagPages = res.pages;
      }, error => {
        if (error.message === 'Error: Access Denied') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          this.router.navigate(['/login']);
        } else {
          if (this.errorSwal) {                
              this.errorSwal.title = error.status;
              this.errorSwal.text = error.error;
              this.errorSwal.show();
          }
          console.log('Error:', error);
        }
      });
  }

  addNewEmptyProduct() {
    const newEvendProduct = new EvendProduct();
    // newEvendProduct.status = -1;
    this.evendProducts.push(newEvendProduct);
    console.log(this.evendProducts);
  }

  addNewIngredient(i) {
    
  }

  onProductTypeChange() {
    console.log(this.productType);
    this.evendProducts = [new EvendProduct()];
    /* this.evendProducts.forEach((evendProduct) => {
      evendProduct.status = -1;
    }); */
  }

  onFileChanged(event, index) {
    this.selectedFiles[index] = event.target.files[0];
    this.imagesFormData[index].append('upfile', this.selectedFiles[index], this.selectedFiles[index].name);
  }

  uploadImageToServer(id: string, index: number) {
    if (this.imagesFormData[index]) {
      this.productService.uploadEvendProductImage(this.imagesFormData[index], id).subscribe(res => {
        console.log(res);
        if (this.successSwal) {                
          this.successSwal.title = 'Başarılı!';
          this.successSwal.show();
      }
        /* this.evendProducts.forEach((evendProduct) => {
          evendProduct.status = -1;
        }); */
      });
    }
  }

  onSubmit() {
    this.submitted = true; 
    console.log(this.evendProducts);
    this.evendProducts.forEach((evendProduct, i) => {
      evendProduct.isHot = this.isHot;
      this.productService.createEvendProduct(evendProduct, this.productType._id).subscribe(res => {
        this.uploadImageToServer(res.evendProductId, i);
        this.onProductTypeChange();
      }, error => {
        if (error.message === 'Error: Access Denied') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          this.router.navigate(['/login']);
        } else {
          if (this.errorSwal) {                
              this.errorSwal.title = error.message;
              this.errorSwal.show();
          }
          console.log('Error:', error);
        }
      });
    });
    
  }

  onScrollBrand() {
    if (this.brandPage + 1 > this.brandPages) { return; }
      $('#page-loader').fadeIn();
      this.brandPage += 1;
      this.brandService.getAllBrands(this.brandPage)
          .subscribe(response => {
              $('#page-loader').fadeOut();
              for (const item of response.docs) {
                  this.brands.push(item);
                  this.brands = [...this.brands];
              }
              this.brandPages = response.pages;
          }, error => {
              $('#page-loader').fadeOut();
              this.errorSwal.title = 'Automat devamı yüklenemedi!';
              this.errorSwal.show();      
          });
  }
  onScrollCategory() {
    if (this.categoryPage + 1 > this.categoryPages) { return; }
      $('#page-loader').fadeIn();
      this.categoryPage += 1;
      this.categoryService.getCategories(this.categoryPage)
          .subscribe(response => {
              $('#page-loader').fadeOut();
              for (const item of response.docs) {
                  this.categories.push(item);
                  this.categories = [...this.categories];
              }
              this.categoryPages = response.pages;
          }, error => {
              $('#page-loader').fadeOut();
              this.errorSwal.title = 'Automat devamı yüklenemedi!';
              this.errorSwal.show();      
          });
  }
  onScrollTags() {
    if (this.tagPage + 1 > this.tagPages) { return; }
      $('#page-loader').fadeIn();
      this.tagPage += 1;
      this.tagService.getAllTags(this.tagPage)
          .subscribe(response => {
              $('#page-loader').fadeOut();
              for (const item of response.docs) {
                  this.tags.push(item);
                  this.tags = [...this.tags];
              }
              this.tagPages = response.pages;
          }, error => {
              $('#page-loader').fadeOut();
              this.errorSwal.title = 'Automat devamı yüklenemedi!';
              this.errorSwal.show();      
          });
  }
  onScrollTypes() {
    if (this.typePage + 1 > this.typePages) { return; }
      $('#page-loader').fadeIn();
      this.typePage += 1;
      this.productService.getEvendProductTypes(this.typePage)
          .subscribe(response => {
              $('#page-loader').fadeOut();
              for (const item of response.docs) {
                  this.productTypes.push(item);
                  this.productTypes = [...this.productTypes];
              }
              this.typePages = response.pages;
          }, error => {
              $('#page-loader').fadeOut();
              this.errorSwal.title = 'Automat devamı yüklenemedi!';
              this.errorSwal.show();      
          });
  }
}





// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/add-product/add-product.component.ts